export default __webpack_public_path__ + "static/media/diamond-clarity@3x.c0537930.png";